import { render, staticRenderFns } from "./CustomMultiSelect.vue?vue&type=template&id=068aa0e2&scoped=true"
import script from "./CustomMultiSelect.vue?vue&type=script&lang=js"
export * from "./CustomMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./CustomMultiSelect.vue?vue&type=style&index=0&id=068aa0e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068aa0e2",
  null
  
)

export default component.exports